import React, { useState } from 'react';
import './Sidebar.css';

const Sidebar = ({ onLogout, activeTab, setActiveTab, userRole, isSidebarOpen, setIsSidebarOpen }) => {
  const [isFeaturesOpen, setIsFeaturesOpen] = useState(false);

  return (
    <div className={`sidebar ${isSidebarOpen ? 'open' : 'closed'}`}>
      <div className="sidebar-header">
        <img 
          src="https://eighteendigitalmarketing.com/wp-content/uploads/2025/07/eighteen-flow-logo@4x-scaled.png" 
          alt="Eighteen Flow Logo" 
          className="sidebar-logo"
          style={{
            maxWidth: '100%',
            height: 'auto',
            maxHeight: '80px'
          }}
        />
        <button
          className="close-sidebar-btn"
          onClick={() => setIsSidebarOpen(false)}
          title="Close Sidebar"
        >
          ✕
        </button>
      </div>

      <div className="sidebar-section">
        <div
          className={`sidebar-subitem ${activeTab === 'all' ? 'active' : ''}`}
          onClick={() => setActiveTab('all')}
        >
          📋 All Tasks
        </div>

        <div
          className={`sidebar-subitem ${activeTab === 'my' ? 'active' : ''}`}
          onClick={() => setActiveTab('my')}
        >
          📝 My Tasks
        </div>

        <div
          className={`sidebar-subitem ${activeTab === 'created' ? 'active' : ''}`}
          onClick={() => setActiveTab('created')}
        >
          ✍️ Task Created By Me
        </div>

        <div
          className={`sidebar-subitem ${activeTab === 'create' ? 'active' : ''}`}
          onClick={() => setActiveTab('create')}
        >
          ✏️ Create New Task+
        </div>

        <div
          className="add-new-task-btn1"
          onClick={() => window.open(
            'https://docs.google.com/spreadsheets/d/13oRBM842C0IFovzwxkmjvA1kgcAx4WnV7ka8WPfuCDg/edit?gid=1186702020#gid=1186702020', 
            '_blank')}
        >
          Daily Sheet
        </div>

        <div
          className="add-new-task-btn2"
          onClick={() => window.open(
            'https://app.officetimer.com/Default.aspx?ReturnPage=%2fEmployee%2fAccountEmployeeTimeEntryPeriodView.aspx', 
            '_blank')}
        >
          Time Sheet
        </div>
      </div>

      {/* User Management section - only visible to admin */}
      {userRole === 'admin' && (
        <div className="sidebar-section">
          <div className="sidebar-item">User Management</div>

          <div
            className={`sidebar-subitem ${activeTab === 'users' ? 'active' : ''}`}
            onClick={() => setActiveTab('users')}
          >
            👤 User List
          </div>

          <div
            className={`sidebar-subitem ${activeTab === 'add-user' ? 'active' : ''}`}
            onClick={() => setActiveTab('add-user')}
          >
            🙋🏻‍♂️ Add User+
          </div>

          <div
            className={`sidebar-subitem ${activeTab === 'user-data' ? 'active' : ''}`}
            onClick={() => setActiveTab('user-data')}
          >
            📊 User Data
          </div>

          {/* Features section with dropdown 
        <div className="sidebar-item" onClick={() => setIsFeaturesOpen(!isFeaturesOpen)}>
          🌟 Features
          <span className={`dropdown-arrow ${isFeaturesOpen ? 'open' : ''}`}>▾</span>
        </div>

        {isFeaturesOpen && (
          <>
            <div
              className={`sidebar-subitem ${activeTab === 'text_speech' ? 'active' : ''}`}
              onClick={() => setActiveTab('text_speech')}
            >
              🗣️ Text to Speech
            </div>
            <div
              className={`sidebar-subitem ${activeTab === 'text_translate' ? 'active' : ''}`}
              onClick={() => setActiveTab('text_translate')}
            >
              🌐 Text Translate
            </div>
            <div
  className={`sidebar-subitem ${activeTab === 'tic_tac_toe' ? 'active' : ''}`}
  onClick={() => setActiveTab('tic_tac_toe')}
>
  ⭕❌ Tic Tac Toe
</div>
<div
  className={`sidebar-subitem ${activeTab === 'sudoku' ? 'active' : ''}`}
  onClick={() => setActiveTab('sudoku')}
>
  🔢 Sudoku
</div>
<div
              className={`sidebar-subitem ${activeTab === 'vtos' ? 'active' : ''}`}
              onClick={() => setActiveTab('vtos')}
            >
              🎬🔊 VtoS
            </div>

          </>
        )}  */}
        </div>
      )}

      <div className="sidebar-bottom">
        <button className="logout-btn" onClick={onLogout}>Log Out</button>
      </div>
    </div>
  );
};

export default Sidebar;
